import { openOverlay } from "overlay"
import CourtPortalInvite from "./CourtPortalInvite.svelte"

export function openCourtPortalInviteOverlay() {
	openOverlay(CourtPortalInvite, { classOverlay: "no-min" })
}
